import React, { useCallback, useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'reactstrap'

import logoMural from 'assets/img/logo_mural_2.png'
import { StudentService } from 'services/student'
import { StudentsHelper } from 'helpers/students'
import Loading from 'components/Loading/Loading'
import StudentsTable from 'components/Table/StudentsTable'

const ConsolidadoFiltroPage = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [classificationStudentsList, setClassificationStudentsList] = useState([])

  const params = new URLSearchParams(history.location.search)
  const universidade = params.get('universidade')
  const curso = params.get('curso')

  const goBack = useCallback(() => {
    history.push('/resultados-consolidados')
  }, [history])

  useEffect(() => {
    const getConsolidateStudentsList = async () => {
      setIsLoading(true)
      try {
        const response = await StudentService.consolidate()
        if (response.status === 200) {
          const classification = StudentsHelper.formatList(response.data.AlunosClassificacao)

          let students = classification
          if (universidade) {
            students = students.filter((item) => item.NomeInstituicao === universidade)
          } else if (curso) {
            students = students.filter((item) => item.NomeCurso === curso)
          }

          console.log({ students })
          setClassificationStudentsList(students)
        }
      } catch (e) {
      } finally {
        setIsLoading(false)
      }
    }

    getConsolidateStudentsList()
  }, [curso, universidade])

  return (
    <div className="section">
      <Container className="text-center">
        <Row>
          <Col style={{ textAlign: 'end' }}>
            <Button onClick={goBack} className="btn-round" color="#000">
              <span>X</span>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <img src={logoMural} style={{ width: 260 }} alt="" />
          </Col>
        </Row>
      </Container>

      <Container className="text-center">
        <h2
          className="title"
          style={{
            fontWeight: 600,
            letterSpacing: 2,
            marginTop: 30,
            fontSize: 32,
          }}
        >
          Resultados consolidados
        </h2>
        <br />
        <p
          className="description"
          style={{
            letterSpacing: 2,
            color: '#000',
            marginTop: -20,
            lineHeight: 1.6,
          }}
        >
          Nesta área, você analisa as aprovações dos seus estudantes por instituição de ensino, curso e posição. Você
          terá os dados consolidados para divulgar em toda a sua comunidade.
        </p>
      </Container>

      <div style={{ padding: '40px 0' }}>
        <Container className="text-center">
          {isLoading ? (
            <Loading />
          ) : (
            <StudentsTable studentsList={classificationStudentsList} setStudentsList={setClassificationStudentsList} />
          )}
        </Container>
      </div>
    </div>
  )
}

export default ConsolidadoFiltroPage
